import { createTheme, type ThemeOptions } from "@mui/material/styles";

const FONT_DISPLAY = '"Cormorant Garamond", Georgia, serif';
const FONT_BODY    = '"Inter", Helvetica, Arial, sans-serif';

export const baseThemeOptions: ThemeOptions = {
  typography: {
    fontFamily: FONT_BODY,

    h1: {
      fontFamily: FONT_DISPLAY,
      fontWeight: 900,
      lineHeight: 1.06,
      letterSpacing: "0.02em",
    },
    h2: {
      fontFamily: FONT_DISPLAY,
      fontWeight: 800,
      lineHeight: 1.18,
      letterSpacing: "-0.02em",
    },
    h3: {
      fontFamily: FONT_DISPLAY,
      fontWeight: 700,
      lineHeight: 1.25,
      letterSpacing: "-0.01em",
    },
    h4: {
      fontFamily: FONT_DISPLAY,
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h5: {
      fontFamily: FONT_DISPLAY,
      fontWeight: 700,
      lineHeight: 1.35,
    },
    h6: {
      fontFamily: FONT_DISPLAY,
      fontWeight: 600,
      lineHeight: 1.4,
    },

    // ── Body Text (Inter — optimised for readability) ────────────
    body1: {
      fontFamily: FONT_BODY,
      fontWeight: 400,
      lineHeight: 1.7,
    },
    body2: {
      fontFamily: FONT_BODY,
      fontWeight: 400,
      lineHeight: 1.65,
      fontSize: "0.9rem",
    },

    // ── Buttons (Inter — clear and action-oriented) ───────────────
    button: {
      fontFamily: FONT_BODY,
      fontWeight: 600,
      letterSpacing: "0.02em",
      textTransform: "none" as const,
    },

    // ── Supporting Styles ─────────────────────────────────────────
    subtitle1: {
      fontFamily: FONT_BODY,
      fontWeight: 500,
      lineHeight: 1.6,
    },
    subtitle2: {
      fontFamily: FONT_BODY,
      fontWeight: 600,
      lineHeight: 1.5,
      fontSize: "0.85rem",
    },
    caption: {
      fontFamily: FONT_BODY,
      fontWeight: 500,
      lineHeight: 1.5,
      fontSize: "0.75rem",
      letterSpacing: "0.04em",
    },
    overline: {
      fontFamily: FONT_BODY,
      fontWeight: 700,
      letterSpacing: "0.12em",
      fontSize: "0.72rem",
    },
  },

  components: {
    // Inherit font on all MUI inputs / selects
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: FONT_BODY,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: FONT_BODY,
          fontWeight: 600,
          textTransform: "none" as const,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          fontFamily: FONT_BODY,
          fontWeight: 600,
        },
      },
    },
  },
};

const muiTheme = createTheme(baseThemeOptions);

export default muiTheme;
